module.exports = __webpack_public_path__ + "static/media/job-post-promo-avatar-3.ea4e5880.png";